import type { RewardPool } from '@shared/api/types/rewardPools';
import { REWARD_POOL_DISTRIBUTION_POLICY } from '@shared/api/types/rewardPools';

import { EntryOptionsList } from './EntryOptionsList';
import { RequirementsList } from './RequirementsList';

type Props = {
  rewardPool: RewardPool;
  hasBorders?: boolean;
  showHeader?: boolean;
  showFooter?: boolean;
};

export const RewardOptions = ({ rewardPool, hasBorders, showHeader, showFooter }: Props) => {
  const ListComponent =
    rewardPool.distribution_policy === REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE_V2
      ? EntryOptionsList
      : RequirementsList;

  return (
    <ListComponent
      rewardPool={rewardPool}
      showHeader={showHeader}
      showFooter={showFooter}
      hasBorders={hasBorders}
    />
  );
};
